import { render, staticRenderFns } from "./FCPUploader.vue?vue&type=template&id=677426e2&scoped=true"
import script from "./FCPUploader.vue?vue&type=script&lang=js"
export * from "./FCPUploader.vue?vue&type=script&lang=js"
import style0 from "./FCPUploader.vue?vue&type=style&index=0&id=677426e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677426e2",
  null
  
)

export default component.exports